import { client, useConfig, useElementData } from '@sigmacomputing/plugin'
import { useEffect } from 'react'
import { formatTypes, themeOptions, themes } from '../utilities'
import '../data-viz/components/PercentOf'
  
export default function App() {

    useEffect(() => {
        client.config.configureEditorPanel([
            {
                name: "source",
                type: "element",
            },
            {
                name: "value",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: "total",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: 'title',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            },
            {
                name: 'theme',
                type: 'dropdown',
                values: themeOptions
            },
            {
                name: 'format',
                type: 'dropdown',
                values: formatTypes
            },
            {
                name: 'helpText',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            }
        ])
    }, [])
        
    const config = useConfig()
    const sigmaData = useElementData(config.source)

    const { value, total, title, theme, helpText, format } = config
    const val = (Object.keys(sigmaData).length && value) ? sigmaData[value][0] : null
    const tot = (Object.keys(sigmaData).length && total) ? sigmaData[total][0] : null

    return (
        <>
            <zero-percent-of
                data-fill={themes[theme]?.dark}
                data-bg={themes[theme]?.light}
                data-value={val}
                data-total={tot}
                data-format={format}
                data-heading={title}
                data-help={helpText}></zero-percent-of>
        </>
    )
}
